<template>
  <div class="page">
    <el-card class="card-basic">
      <el-row>
        <el-form :inline="true" :model="formInline" class="card-form demo-form-inline">
          <el-form-item label="工程名称">
            <el-select @change="projectChange" clearable v-model="project" placeholder="请选择工程" value-key="projectId">
              <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测站名称">
            <el-select @change="stationChange" clearable v-model="station" value-key="projectStationId"
              placeholder="请选择测站">
              <el-option v-for="item in stationList" :key="'remote-'+item.projectStationId" :label="
                  item.projectStationName + '(' + item.projectStationId + ')'
                " :value="item">
                <span style="float: left">{{ item.projectStationName + '(' + item.projectStationId + ')' }}</span>
                <span v-if="item.online" style="float: right; color: #67C23A; font-size: 13px">在线</span>
                <span v-else style="float: right; color: #F56C6C; font-size: 13px">离线</span>
              </el-option>

            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="card-basic">
      <el-row class="btn-rows">
        <el-button size="mini" @click="syncStationTime('校时')" :loading="controllerState.syncTime" class="btn-green"
          type="info">校时
        </el-button>
        <el-button size="mini" @click="readStationTime('读取时间')" :loading="controllerState.readTime" class="btn-green"
          type="info">读取时间
        </el-button>
        <el-button size="mini" @click="readStationIntervalTime('读取采集间隔')" :loading="controllerState.readIntervalTime"
          class="btn-green" type="info">读取采集间隔
        </el-button>
        <el-button size="mini" @click="serverConfigFormVisible = true" :loading="controllerState.syncConfig"
          type="warning">服务器配置</el-button>
        <el-button size="mini" @click="getStaionVer('固件版本')" :loading="controllerState.getMnVer" type="success">固件版本
        </el-button>
        <el-button size="mini" @click="upgradeStationVer('升级固件')" :loading="controllerState.upgradeVer" type="success">
          升级固件</el-button>
        <el-button size="mini" @click="getPointConfig('读取测点配置')" :loading="controllerState.pointConfig" type="primary">
          读取测点配置</el-button>
        <el-button size="mini" @click="getAllPointDataClick('读取全部测点数据')" type="primary"
          :loading="controllerState.allPointData">
          读取全部测点数据</el-button>
        <el-button size="mini" @click="startSeriesClick('连续采集')" type="danger">
          连续采集</el-button>
        <!-- <el-button size="mini" @click="stopSeriesClick('停止采集')" :disabled="controllerState.stopStatue" type="danger">
          停止采集</el-button> -->
        <!-- <el-button size="mini" @click="showMsg('复位DTU')" type="danger">复位DTU</el-button> -->
      </el-row>
      <el-row>
        <el-table border :data="filterTableData" @selection-change="handleSelectionChange">
          >
          <el-table-column prop="projectPointChannel" label="通道号" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="projectPointId" label="测点编号" header-align="center" align="center"></el-table-column>
          <el-table-column label="测点名称" width="120" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.row.projectPointName }}
            </template>
          </el-table-column>
          <el-table-column prop="projectPointEnable" label="是否启用" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.row.projectPointEnable === 'true' ? '启用' : '未启用' }}
            </template>
          </el-table-column>
          <el-table-column prop="projectPointUpperLimit" label="上限" header-align="center" align="center">
            <template slot-scope="scope">{{getUpperData(scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="projectPointLowerLimit" label="下限" header-align="center" align="center">
            <template slot-scope="scope">{{ getLowerData(scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="projectRealData" label="当前测值" header-align="center" align="center"></el-table-column>
          <el-table-column prop="projectComputeData" label="监测值" header-align="center" align="center">
            <template slot-scope="scope">
              {{scope.row.projectComputeData}} {{scope.row.projectPointUnit}}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="getSinglePointDataClick(scope.row,scope.$index)" size="small">读取当前测值
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <Continue :channelList="channelList" :projectName="project.projectName" :projectId="project.projectId"
      :stationId=" station.projectStationId" :start="start" :closeLine.sync="showLine" :dialogTableVisible="showLine"
      :pointList="pointList" />

    <!-- 修改服务器IP和端口 -->
    <el-dialog title="服务器信息" :visible.sync="serverConfigFormVisible">
      <el-form ref="serverConfigForm" :model="serverConfigForm" :rules="ServerConfigRules">
        <el-form-item label="IP" prop="ip">
          <el-input type="text" v-model="serverConfigForm.ip" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="端口" prop="port">
          <el-input type="number" min="1000" max="65536" v-model="serverConfigForm.port" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="serverConfigFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="syncServerConfigClick('服务器配置')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Continue from "./components/ContinueComponent";
import { listProject } from "@/api/projectApi";
import * as dayjs from "dayjs";
import {
  syncTimeMessage, readTimeMessage, syncServerConfig, getStationVer, stationUpgrade, sendPointConfig,
  startSeriesRequest, stopSeriesRequest, getAllPointDataRequest, getSinglePointDataRequest, getSentTimeIntervalRequest
} from "@/api/messageApi";
// import { queryData, queryLineData } from "@/api/dataApi";
import { listStation } from "@/api/stationApi";
import { listPoint } from "@/api/pointApi";
import { FORMULA_LIST, isCustomizationDevice, getCustomizationTitle } from "../station/pointPage";
export default {
  components: { Continue },
  data() {
    return {
      serverConfigFormVisible: false,
      serverConfigForm: {
        ip: "",
        port: ""
      },
      formulaList: FORMULA_LIST,
      formInline: {},
      showLine: false,
      multipleSelection: [],
      project: "",
      station: "",
      point: "",
      projectList: [],
      stationList: [],
      pointList: [],
      ServerConfigRules: {
        ip: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        port: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ]
      },
      controllerState: {
        syncTime: false,
        readTime: false,
        syncConfig: false,
        getMnVer: false,
        upgradeVer: false,
        pointConfig: false,
        startStatue: false,
        stopStatue: true,
        readIntervalTime: false,
        allPointData: false
      },
      start: ""
    };
  },
  mounted() {
    this.loadProjectList();
  },
  methods: {
    loadProjectList() {
      this.loadingProject = true;
      listProject({}).then(res => {
        this.loadingProject = false;
        const resp = res.data;
        if (resp.code === 200) {
          this.projectList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    loadStationList() {
      this.station = {};
      listStation({ projectId: this.project.projectId }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.stationList = resp.content;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    projectChange() {
      this.station = {};
      // 加载测站
      this.loadStationList();
    },
    stationChange() {
      this.point = "";
      if (!this.station) {
        this.pointList = [];
        return;
      }
      listPoint({
        projectId: this.project.projectId,
        projectStationId: this.station.projectStationId
      }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          const res = resp.content;
          if (res) {
            res.sort((a, b) => {
              return parseInt(a.projectPointChannel) - parseInt(b.projectPointChannel);
            });
          }
          this.pointList = res;
        } else {
          this.$message.warning(resp.msg ? resp.msg : "未加载到数据");
        }
      });
    },
    showMsg(val) {
      const p = this.station.projectStationName;
      this.$message.success(p + "的" + val + " 操作成功！");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    syncStationTime(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.syncTime = true;
        syncTimeMessage({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({
              showClose: true, duration: 6000, message: v + ": " + res.data.content
            });
          }
          this.controllerState.syncTime = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.syncTime = false;
        });
      }
    },
    syncServerConfigClick(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.$refs.serverConfigForm.validate(valid => {
          if (valid) {
            this.serverConfigFormVisible = false;
            this.controllerState.syncConfig = true;
            syncServerConfig({
              stationId: this.station.projectStationId,
              ...this.serverConfigForm
            }).then(res => {
              if (res.data.code !== 200) {
                this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
              } else {
                this.$message.success({ showClose: true, duration: 6000, message: v + ": " + res.data.content });
              }
              this.controllerState.syncConfig = false;
            }).catch(e => {
              this.$message.error(v + ":系统处理失败");
              this.controllerState.syncConfig = false;
            });
          }
        });
      }
    },
    readStationIntervalTime(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.readIntervalTime = true;
        getSentTimeIntervalRequest({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({ showClose: true, duration: 6000, message: "当前采集间隔为: " + parseInt(res.data.content) + " 分钟" });
          }
          this.controllerState.readIntervalTime = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.readIntervalTime = false;
        });
      }
    },
    readStationTime(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.readTime = true;
        readTimeMessage({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({ showClose: true, duration: 6000, message: "当前时间: " + dayjs(res.data.content, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss") });
          }
          this.controllerState.readTime = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.readTime = false;
        });
      }
    },
    getStaionVer(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.getMnVer = true;
        getStationVer({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({
              showClose: true, duration: 6000, message: v + ": " + res.data.content
            });
          }
          this.controllerState.getMnVer = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.getMnVer = false;
        });
      }
    },
    upgradeStationVer(v) {
      this.serverConfigFormVisible = false;
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.upgradeVer = true;
        stationUpgrade({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({
              showClose: true, duration: 6000, message: v + ": " + res.data.content
            });
          }
          this.controllerState.upgradeVer = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.upgradeVer = false;
        });
      }
    },
    getPointConfig(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.pointConfig = true;
        sendPointConfig({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            const resp = JSON.parse(res.data.content);
            let htmlStr = "";
            const keyList = Object.keys(resp).sort();
            for (let i = 0; i < keyList.length; i++) {
              const key = keyList[i];
              const x = " 通道[" + key + "]的配置ID是: [" + resp[key] + "]<br>";
              htmlStr += x;
            }

            this.$alert(htmlStr, "测站配置", {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              callback: action => {
              }
            });
          }
          this.controllerState.pointConfig = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.pointConfig = false;
        });
      }
    },
    startSeriesClick(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.start = dayjs().subtract(10, "minutes").format("YYYY-MM-DD HH:mm:ss");
        this.controllerState.startStatue = true;
        startSeriesRequest({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.controllerState.startStatue = false;
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.showLine = true;
            this.$message.success({
              showClose: true, duration: 6000, message: v + ": " + res.data.content
            });
          }
          this.controllerState.stopStatue = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.startStatue = false;
        });
      }
    },
    stopSeriesClick(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.stopStatue = true;
        stopSeriesRequest({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.controllerState.stopStatue = true;
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            this.$message.success({
              showClose: true, duration: 6000, message: v + ": " + res.data.content
            });
          }
          this.controllerState.startStatue = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.stopStatue = false;
        });
      }
    },
    getAllPointDataClick(v) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        this.controllerState.allPointData = true;
        getAllPointDataRequest({
          stationId: this.station.projectStationId,
        }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            const queryData = JSON.parse(res.data.content);
            const plist = JSON.parse(JSON.stringify(this.pointList));
            plist.map(p => {
              const chid = this.prefixZero(parseInt(p.projectPointChannel) + 130, 4);
              p.projectRealData = queryData[chid];
              p.projectComputeData = queryData["c_" + chid];
              // p.projectComputeData = queryData[chid];
            });
            this.pointList = plist;
            this.$message.success({
              showClose: true, duration: 6000, message: "读取成功"
            });
          }
          this.controllerState.allPointData = false;
        }).catch(e => {
          this.$message.error(v + ":系统处理失败");
          this.controllerState.allPointData = false;
        });
      }
    },
    getSinglePointDataClick(v, index) {
      if (!this.station || !this.station.projectStationId) {
        this.$message.error("请选择一个测站");
      } else {
        const loading = this.$loading({
          lock: true,
          text: "数据加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.controllerState.singlePointData = true;
        getSinglePointDataRequest({
          stationId: this.station.projectStationId,
          channelId: v.projectPointChannel,
        }).then(res => {
          loading.close();
          if (res.data.code !== 200) {
            this.$message.error({ showClose: true, duration: 6000, message: res.data.msg });
          } else {
            const chId = this.prefixZero(parseInt(v.projectPointChannel) + 130, 4);
            const queryData = JSON.parse(res.data.content);
            v.projectRealData = queryData[chId];
            v.projectComputeData = queryData["c_" + chId];
            this.$set(this.pointList, index, v);
            console.log(queryData, chId);
            this.$message.success({
              showClose: true, duration: 6000, message: "读取成功"
            });
          }
          this.controllerState.singlePointData = false;
        }).catch(e => {
          loading.close();
          this.$message.error("读取当前测值:系统处理失败");
          this.controllerState.singlePointData = false;
        });
      }
    },
    prefixZero(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
    getLowerData(row) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "lower");

        if (selectedDevice.hiddenUnit) {
          const unitObj = obj.find(v => v.key === "unit").val;
          const res = [];
          const u = initObj.val.map(u => u.val);
          for (let i = 0; i < u.length; i++) {
            res[i] = u[i] + unitObj[i].val;
          }
          return res.join(" , ");
        } else {
          return initObj.val.map(u => u.val + row.projectPointUnit).join(",");
        }
      } else {
        return row.projectPointLowerLimit + row.projectPointUnit;
      }
    },
    getUpperData(row) {
      const selectedDevice = this.getDeviceConfigDetail(row.projectPointDeviceType);
      if (selectedDevice.customization) {
        const init = row.projectPointDeviceInit;
        const obj = JSON.parse(init);
        const initObj = obj.find(v => v.key === "upper");

        if (selectedDevice.hiddenUnit) {
          const unitObj = obj.find(v => v.key === "unit").val;
          const res = [];
          const u = initObj.val.map(u => u.val);
          for (let i = 0; i < u.length; i++) {
            res[i] = u[i] + unitObj[i].val;
          }
          return res.join(" , ");
        } else {
          return initObj.val.map(u => u.val + row.projectPointUnit).join(",");
        }
      } else {
        return row.projectPointUpperLimit + row.projectPointUnit;
      }
    },
    getDeviceConfigDetail(id) {
      const selectedDevice = this.formulaList.find(
        v => v.val === id
      );
      return selectedDevice;
    }
  },
  computed: {
    filterTableData() {
      const data = this.pointList;
      return data;
    },
    channelList() {
      const data = this.pointList;
      const newDataList = [];
      data.forEach(item => {
        const a = getCustomizationTitle(item.projectPointDeviceType, 0);
        newDataList.push({
          idx: 0,
          pre: a,
          fkey: item.projectPointId + a,
          name: item.projectPointName + a,
          key: item.projectPointId
        });
        if (isCustomizationDevice(item.projectPointDeviceType)) {
          const b = getCustomizationTitle(item.projectPointDeviceType, 1);
          newDataList.push({
            idx: 1,
            pre: b,
            fkey: item.projectPointId + b,
            name: item.projectPointName + b,
            key: item.projectPointId
          });
        }
      });
      return newDataList;
    }
  }
};
</script>
<style scoped>
.card-basic {
  margin: 5px 10px;
}
.card-form .el-form-item {
  margin-bottom: 0px;
}
.btn-rows .el-button {
  margin-top: 8px;
}
.btn-green {
  background-color: #009966;
  border-color: #009966;
}
</style>
